


























import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { ReceiptModel } from '@/models/receipt';
import { SummaryReceiptModel } from '@/models/summary-receipt';
import ListReceipt from './components/ListReceipt.vue';
import SummaryReceipt from './components/SummaryReceipt.vue';
import FilterBox from './components/FilterBox.vue';
import authService from '@/services/auth-services';
import receiptServices from '@/services/receipt-services';
const numeral = require('numeral');
@Component({
    components: {
        ListReceipt,
        Loading,
        Paging,
        SummaryReceipt,
        FilterBox
    }
})
export default class MainReceipt extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: '', 
        startDate: '', 
        endDate: '', 
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listReceipt: ReceiptModel[] = [];
    private summaryReceipt: SummaryReceiptModel = new SummaryReceiptModel();
    private isLoading = false;
    private customerInfo: any = {};

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.getCustomersInfo();
        await this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private onFilterChanged(data: any) {
        this.filterProp.searchText = data.searchText;
        this.filterProp.startDate = data.startDate;
        this.filterProp.endDate = data.endDate;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        const result = await receiptServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            this.summaryReceipt = new SummaryReceiptModel();
            const tmpListReceipt: ReceiptModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryReceipt.totalReceipt = result.data.total;
            for (const item of result.data.summary) {
                if(item.Status === 0) {
                    this.summaryReceipt.totalUnExportedWeight = item.Weight;
                    this.summaryReceipt.totalUnExportedVolume = item.Volume;
                }
                if(item.Status === 1) {
                    this.summaryReceipt.totalExportedWeight = item.Weight;
                    this.summaryReceipt.totalExportedVolume  = item.Volume ;
                }
            }
            
            for (const item of result.data.data) {
                const receipt = new ReceiptModel();
                receipt.id = item.ID;
                receipt.status = item.Status;
                receipt.weight = item.Weight;
                receipt.volume = item.Volume;
                receipt.numberOfPack = item.NumberOfPack;
                receipt.totalAmount = item.TotalAmount;
                receipt.createdDate = item.CreatedDate;
                receipt.statusDetail = DATA.exportReceiptStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };

                tmpListReceipt.push(receipt);
            }
            this.listReceipt = tmpListReceipt;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }
        if (this.filterProp.startDate !== null &&
            this.filterProp.startDate !== undefined &&
            this.filterProp.startDate !== '') {
                paramsFilter.filters.push({
                    column: 'CreatedDate',
                    value: this.filterProp.startDate,
                    condition: 'd_greater_than_or_equal'
                });
        }
        if (this.filterProp.endDate !== null &&
            this.filterProp.endDate !== undefined &&
            this.filterProp.endDate !== '') {
                paramsFilter.filters.push({
                    column: 'CreatedDate',
                    value: this.filterProp.endDate,
                    condition: 'd_less_than_or_equal'
                });
        }
        return paramsFilter;
    }

    get amountNeedPay() {
        return this.listReceipt.reduce((amount: number, order: ReceiptModel) => {
            return amount + (order.isChecked === true && order.status === 3 ? order.totalAmount || 0 : 0)
        }, 0);
    }

    get totalChoose() {
        return this.listReceipt.filter(x => x.isChecked === true).length;
    }
}
